/**
 * CV extraction is a hint, NEVER authoritative employment history.
 * Keep all writes in the existing manual /worker/employment-history/amend flow.
 * Don't invent dates to make an extracted entry appear ready for verification.
 */
const normalizedText = (value) => String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

const exactDateOrBlank = (value) => {
  const candidate = String(value || '').trim().slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(candidate) ? candidate : '';
};

export function getCvHistorySuggestions(cvStatus, officialEntries = []) {
  if (cvStatus?.has_cv !== true || !Array.isArray(cvStatus?.employment_history?.entries)) return [];
  const official = Array.isArray(officialEntries) ? officialEntries : [];

  return cvStatus.employment_history.entries.slice(0, 50).flatMap((row, index) => {
    if (!row || typeof row !== 'object' || Array.isArray(row)) return [];
    const employer = String(row.employer_name || row.employer || row.company || row.organisation || '').trim();
    const role = String(row.job_title || row.role || row.position || '').trim();
    const start = exactDateOrBlank(row.start_date || row.from_date);
    const end = exactDateOrBlank(row.end_date || row.to_date);
    if (!employer && !role) return [];
    const isCurrent = row.is_current === true || row.current === true;
    const matched = official.find((entry) =>
      normalizedText(entry.employer_name || entry.employer) === normalizedText(employer) &&
      Boolean(start) && exactDateOrBlank(entry.start_date) === start &&
      // Same employer and start date can still represent different roles.
      (!role || !entry.job_title || normalizedText(entry.job_title) === normalizedText(role))
    ) || null;
    return [{
      key: `cv-role-${index}`,
      employer,
      role,
      originalStart: String(row.start_date || row.from_date || '').trim(),
      originalEnd: String(row.end_date || row.to_date || '').trim(),
      existing: matched,
      draft: matched || {
        employer_name: employer,
        job_title: role,
        start_date: start,
        end_date: isCurrent ? '' : end,
        is_current: isCurrent,
      },
    }];
  });
}
